import { render } from "./OidoCardTitle.vue?vue&type=template&id=07bd945b&scoped=true"
import script from "./OidoCardTitle.vue?vue&type=script&lang=js"
export * from "./OidoCardTitle.vue?vue&type=script&lang=js"

import "./OidoCardTitle.vue?vue&type=style&index=0&id=07bd945b&scoped=true&lang=css"
import "./OidoCardTitle.vue?vue&type=style&index=1&id=07bd945b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07bd945b"]])

export default __exports__